import { Link } from "react-router-dom";
import { FileText } from "lucide-react";

export default function F24Page() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8" data-testid="f24-page">
      <div className="flex items-center gap-3">
        <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-bordeaux text-white">
          <FileText className="h-6 w-6" />
        </span>
        <h1 className="section-title">F24</h1>
      </div>
      <p className="mt-4 text-muted-foreground">
        Una spiegazione semplice del modello di versamento più usato in Italia e del suo legame con l'attività nello spettacolo.
      </p>
      <div className="mt-8 space-y-8">
        <section>
          <h2 className="font-heading text-xl font-semibold text-bordeaux-dark">Cos'è il modello F24</h2>
          <div className="mt-3 space-y-3 text-base leading-relaxed text-foreground/80">
            <p>
              Il <strong className="text-bordeaux">modello F24</strong> è il modulo utilizzato in Italia per versare in
              un'unica operazione la maggior parte delle imposte, dei contributi previdenziali e dei premi assicurativi
              dovuti allo Stato e agli enti previdenziali.
            </p>
            <p>
              Si chiama "unificato" proprio perché permette di pagare con un solo modello diversi tipi di tributi e
              contributi, indicando per ciascuno il codice e l'importo corrispondente. Il versamento può avvenire in
              banca, presso gli uffici postali, tramite home banking o attraverso i servizi online dell'Agenzia delle Entrate.
            </p>
          </div>
        </section>

        <section>
          <h2 className="font-heading text-xl font-semibold text-bordeaux-dark">Perché riguarda chi lavora nello spettacolo</h2>
          <div className="mt-3 space-y-3 text-base leading-relaxed text-foreground/80">
            <p>
              Le prestazioni artistiche — concerti, serate, spettacoli, esibizioni nei locali — sono soggette a
              <strong className="text-bordeaux"> adempimenti previdenziali e fiscali</strong>: i compensi percepiti da
              cantanti, musicisti, D.J. e altri lavoratori dello spettacolo danno infatti luogo al versamento dei
              contributi previdenziali.
            </p>
            <p>
              Il modello F24 è uno degli strumenti attraverso cui questi versamenti possono essere effettuati: per
              questo è strettamente collegato alla vita lavorativa dell'artista e alla regolarità della sua posizione
              previdenziale.
            </p>
          </div>
        </section>

        <section>
          <h2 className="font-heading text-xl font-semibold text-bordeaux-dark">Perché è importante essere in regola</h2>
          <div className="mt-3 space-y-3 text-base leading-relaxed text-foreground/80">
            <p>
              Versare correttamente i contributi significa tutelare il proprio percorso lavorativo: i contributi
              accumulati contano ai fini della pensione e delle altre prestazioni previdenziali previste per i
              lavoratori dello spettacolo.
            </p>
            <p>
              Modalità, codici e scadenze possono variare a seconda della situazione personale e del tipo di
              collaborazione: <strong className="text-bordeaux">per informazioni specifiche sulla propria situazione
              è possibile contattare ENPALSBOX.</strong> Il nostro team ti aiuterà a orientarti.
            </p>
          </div>
        </section>
      </div>
      <div className="mt-8 flex flex-wrap gap-3">
        <Link to="/contatti" data-testid="f24-contact-btn" className="btn-bordeaux">CONTATTA ENPALSBOX</Link>
        <Link to="/iscriviti" data-testid="f24-register-btn" className="btn-outline-bordeaux">ISCRIVITI</Link>
      </div>
    </div>
  );
}
